(function () {
  if (customElements.get('ce-product-variant-picker') !== undefined) {
    return;
  }

  class ProductVariantPicker extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        product: 'ce-product',
        input: '[data-product-variant-picker-input]',
        inputUser: '[data-product-variant-picker-input-user]',
        radioGroup: '[data-product-variant-picker-radio-group]',
        json: '[data-product-variant-picker-json]',
      };

      this.elements = null;
      this.selectedOptions = [];
      this.variantOptions = [];

      this.handleProductVariantId = this.handleProductVariantId.bind(this);
      this.handleProductOption = this.handleProductOption.bind(this);
      this.handleChangeDropDown = this.handleChangeDropDown.bind(this);
      this.handleChangePills = this.handleChangePills.bind(this);
    }

    get option1() {
      return this.getAttribute('option-1');
    }

    set option1(value) {
      this.setAttribute('option-1', value);
    }

    get option2() {
      return this.getAttribute('option-2');
    }

    set option2(value) {
      this.setAttribute('option-2', value);
    }

    get option3() {
      return this.getAttribute('option-3');
    }

    set option3(value) {
      this.setAttribute('option-3', value);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    static get observedAttributes() {
      return ['option-1', 'option-2', 'option-3', 'variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'option-1':
          if (newValue !== null && newValue !== 'null') {
            this._toggleUserInputOptions(0);
            this._updateUserInput(0, newValue);
          }
          break;
        case 'option-2':
          if (newValue !== null && newValue !== 'null') {
            this._toggleUserInputOptions(1);
            this._updateUserInput(1, newValue);
          }
          break;
        case 'option-3':
          if (newValue !== null && newValue !== 'null') {
            this._updateUserInput(2, newValue);
          }
          break;
        case 'variant-id':
          if (newValue !== null) {
            this.elements.input.value = newValue;
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        product: this.closest(this.selectors.product),
        input: this.querySelector(this.selectors.input),
        inputUser: [
          this.querySelector(`${this.selectors.inputUser}[data-position="0"]`),
          this.querySelector(`${this.selectors.inputUser}[data-position="1"]`),
          this.querySelector(`${this.selectors.inputUser}[data-position="2"]`)
        ],
        inputRadioGroup: [
          this.querySelector(`${this.selectors.radioGroup}[data-position="0"]`),
          this.querySelector(`${this.selectors.radioGroup}[data-position="1"]`),
          this.querySelector(`${this.selectors.radioGroup}[data-position="2"]`),
        ],
        json: this.querySelector(this.selectors.json),
      };

      this.elements.input.removeAttribute('disabled');

      this._parseJson();

      this.elements.product.addEventListener('ce-product:variant-id', this.handleProductVariantId);
      this.elements.product.addEventListener('ce-product:option-1', this.handleProductOption);
      this.elements.product.addEventListener('ce-product:option-2', this.handleProductOption);
      this.elements.product.addEventListener('ce-product:option-3', this.handleProductOption);

      this.addEventListener('change', this.handleChangeDropDown);
      this.addEventListener('ce-radio-group:change', this.handleChangePills);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.product.removeEventListener('ce-product:variant-id', this.handleProductVariantId);
      this.elements.product.removeEventListener('ce-product:option-1', this.handleProductOption);
      this.elements.product.removeEventListener('ce-product:option-2', this.handleProductOption);
      this.elements.product.removeEventListener('ce-product:option-3', this.handleProductOption);

      this.removeEventListener('change', this.handleChangeDropDown);
      this.removeEventListener('ce-radio-group:change', this.handleChangePills);
    }

    _parseJson() {
      const maxNumOptions = 3;
      const json = JSON.parse(this.elements.json.textContent);
      const selectedOptions = json.selectedOptions;

      for (let i = 0; i < maxNumOptions; i++) {
        this.selectedOptions[i] = selectedOptions[i] || null;
      }

      this.variantOptions = json.variantOptions;

      this.elements.json.remove();
    }

    _setValidOptions(position, inputValue) {
      switch (position) {
        case '0': {
          const value = inputValue;

          this.selectedOptions[0] = value;

          if (this.option2 === 'null') {
            break;
          }

          let value2 = null;
          const validValuesForOption2 = this.variantOptions.filter((options) => options[0] === value).map((options) => options[1]);
          if (validValuesForOption2.includes(this.selectedOptions[1])) {
            value2 = this.selectedOptions[1];
          } else {
            value2 = validValuesForOption2[0];
          }

          this.selectedOptions[1] = value2;

          if (this.option3 === 'null') {
            break;
          }

          let value3 = null;
          const validValuesForOption3 = this.variantOptions.filter((options) => options[0] === value && options[1] === value2).map((options) => options[2]);
          if (validValuesForOption3.includes(this.selectedOptions[2])) {
            value3 = this.selectedOptions[2];
          } else {
            value3 = validValuesForOption3[0];
          }

          this.selectedOptions[2] = value3;

          break;
        }
        case '1': {
          const value2 = inputValue;

          this.selectedOptions[1] = value2;

          if (this.option3 === 'null') {
            break;
          }

          let value3 = null;
          const validValuesForOption3 = this.variantOptions.filter((options) => options[0] === this.selectedOptions[0] && options[1] === value2).map((options) => options[2]);
          if (validValuesForOption3.includes(this.selectedOptions[2])) {
            value3 = this.selectedOptions[2];
          } else {
            value3 = validValuesForOption3[0];
          }

          this.selectedOptions[2] = value3;

          break;
        }
        case '2': {
          const value3 = inputValue;

          this.selectedOptions[2] = value3;

          break;
        }
      }

      this.elements.product.setVariantWithOptions(this.selectedOptions);
    }

    _updateUserInput(position, value) {
      if (this.elements.inputUser[position].dataset.type === 'select') {
        this.elements.inputUser[position].value = value;
      } else {
        for (let i = 0; i < this.elements.inputUser[position].children.length; i++) {
          const radioButton = this.elements.inputUser[position].children[i];

          if (radioButton.dataset.value === value) {
            this.elements.inputRadioGroup[position].currentChild = i;
            break;
          }
        }
      }
    }

    _toggleUserInputOptions(position) {
      switch (position) {
        case 0: {
          const validValuesForOption2 = this.variantOptions.filter((options) => options[0] === this.option1).map((options) => options[1]);
          const validValuesForOption3 = this.variantOptions.filter((options) => options[0] === this.option1 && options[1] === this.option2).map((options) => options[2]);

          if (this.elements.inputUser[0].dataset.type === 'select') {
            if (this.option2 !== 'null') {
              for (let option of this.elements.inputUser[1].children) {
                option.disabled = !validValuesForOption2.includes(option.value);
              }
            }

            if (this.option3 !== 'null') {
              for (let option of this.elements.inputUser[2].children) {
                option.disabled = !validValuesForOption3.includes(option.value);
              }
            }
          } else {
            if (this.option2 !== 'null') {
              for (let i = 0; i < this.elements.inputUser[1].children.length; i++) {
                const radioButton = this.elements.inputUser[1].children[i];

                if (validValuesForOption2.includes(radioButton.dataset.value)) {
                  radioButton.removeAttribute('aria-disabled');
                } else {
                  radioButton.setAttribute('aria-disabled', 'true');
                }
              }
            }

            if (this.option3 !== 'null') {
              for (let i = 0; i < this.elements.inputUser[2].children.length; i++) {
                const radioButton = this.elements.inputUser[2].children[i];

                if (validValuesForOption3.includes(radioButton.dataset.value)) {
                  radioButton.removeAttribute('aria-disabled');
                } else {
                  radioButton.setAttribute('aria-disabled', 'true');
                }
              }
            }
          }

          break;
        }
        case 1: {
          const validValuesForOption3 = this.variantOptions.filter((options) => options[0] === this.option1 && options[1] === this.option2).map((options) => options[2]);

          if (this.elements.inputUser[0].dataset.type === 'select') {
            if (this.option3 !== 'null') {
              for (let option of this.elements.inputUser[2].children) {
                option.disabled = !validValuesForOption3.includes(option.value);
              }
            }
          } else {
            if (this.option3 !== 'null') {
              for (let i = 0; i < this.elements.inputUser[2].children.length; i++) {
                const radioButton = this.elements.inputUser[2].children[i];

                if (validValuesForOption3.includes(radioButton.dataset.value)) {
                  radioButton.removeAttribute('aria-disabled');
                } else {
                  radioButton.setAttribute('aria-disabled', 'true');
                }
              }
            }
          }

          break;
        }
      }
    }

    handleProductVariantId(event) {
      this.variantId = event.detail;
    }

    handleProductOption(event) {
      const { position, value } = event.detail;

      switch (position) {
        case 0:
          this.option1 = value;
          break;
        case 1:
          this.option2 = value;
          break;
        case 2:
          this.option3 = value;
          break;
      }
    }

    handleChangeDropDown(event) {
      const index = event.target.dataset.position;
      const value = event.target.value;
      this._setValidOptions(index, value);
    }

    handleChangePills(event) {
      const { index, value } = event.detail;
      this._setValidOptions(index, value);
    }
  }

  customElements.define('ce-product-variant-picker', ProductVariantPicker);
})();
